import { EtyMBTSPersona, EtyMBTSScenario } from "../types/entities.interface";
import { EWhiteLabelingClient } from "../types/misc.enum";

export const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const getWhiteLabelingClient = (): EWhiteLabelingClient => {
    const origin = window.location.origin;

    if (origin.startsWith('https://ridleyconsulting')) {
        return EWhiteLabelingClient.RIDLEY_CONSULTING;
    };

    return EWhiteLabelingClient.MINDSHIELD;
};

export const getScenarioColor = (scenario: Partial<EtyMBTSScenario> | null): { main: string; bg: string; } => {
    const defaultColor = { main: '#3B82F6', bg: '#EBF2FE' };

    if (!scenario) return defaultColor;

    return {
        main: scenario.color_main ?? defaultColor.main,
        bg: scenario.color_bg ?? defaultColor.bg
    };
};

type InteractionLimitSource = Partial<EtyMBTSPersona> & {
    personas?: Partial<EtyMBTSPersona>[];
};

export type TInteractionLimits = { eligibility: number; level1: number; level2: number };
export type TConversationCompletionThreshold = 'level1' | 'level2' | null;

export const getInteractionLimits = (source: InteractionLimitSource | null): TInteractionLimits => {
    const defaultLimits = { eligibility: 5, level1: 6, level2: 15 };

    if (!source) return defaultLimits;

    const fromPersona = source.personas?.[0];

    return {
        eligibility: source.interaction_limit_eligibility ?? fromPersona?.interaction_limit_eligibility ?? defaultLimits.eligibility,
        level1: source.interaction_limit_level1 ?? fromPersona?.interaction_limit_level1 ?? defaultLimits.level1,
        level2: source.interaction_limit_level2 ?? fromPersona?.interaction_limit_level2 ?? defaultLimits.level2,
    };
};

export const countPersonaMessages = (messages: { by: string }[]): number => {
    return messages.filter((message) => message.by === 'persona').length;
};

export const canProceedFromConversation = (personaMessageCount: number, limits: TInteractionLimits): boolean => {
    return personaMessageCount >= limits.eligibility;
};

export const shouldOpenIntermediateProceedWindow = (personaMessageCount: number, limits: TInteractionLimits): boolean => {
    return personaMessageCount >= limits.eligibility && personaMessageCount < limits.level1;
};

export const resolveCompletionThreshold = (
    personaMessageCount: number,
    limits: TInteractionLimits,
    continueMode: boolean,
): TConversationCompletionThreshold => {
    if (continueMode) {
        return personaMessageCount >= limits.level2 ? 'level2' : null;
    };

    if (personaMessageCount >= limits.level2) return 'level2';
    if (personaMessageCount >= limits.level1) return 'level1';
    return null;
};